// todo: change activeId after sync
import _ from 'underscore';
import Backbone from 'backbone';

import Config from './config';
import ActionList from './actionList';

import url from './urlify';
import { Insert } from './service/live';
import { save } from './model/actions';
import { promisify } from './utils/promisify';

export default Backbone.Collection.extend( {
	
	initialize(items, options) {
        if (!options) 
            if (!items) {
                options = {}, items = [];
            } else if (items instanceof Array)
                options = {};
            else
                options = items, items = [];
        
		this.endpoint = options.endpoint || this.endpoint;
		this.responseAt = options.responseAt || this.responseAt || 'items';
        this.countAt = options.countAt || this.countAt;
        this.model = options.model || this.model;
		this.filters = {};
        this.activeId = undefined;
        this.parseResponse = options.parseResponse || this.parseResponse;
        this.restoreActive = options.restoreActive || this.restoreActive;
        
        // let's rewrite actions definition
        if (options.actions)    
            this.setActions( options.actions );

        // todo: bug here
        this.options = options;
		
		Backbone.Collection.prototype.initialize.call( this, 
            items, options );
	},
	
	sync(method, collection, options) {
		// By setting the dataType to "jsonp", jQuery creates a function
		// and adds it as a callback parameter to the request, e.g.:
		// [url]&callback=jQuery19104472605645155031_1373700330157&q=bananarama
		// If you want another name for the callback, also specify the
		// jsonpCallback option.
		// After this function is called (by the JSONP response), the script tag
		// is removed and the parse method is called, just as it would be
        // when AJAX was used.
        if (undefined === this.jsonp || true === this.jsonp)
		    options.dataType = "jsonp";
		return Backbone.sync(method, collection, options);
	},

	parse(response) {
        const modelAttrs = this.responseAt
            ? response[this.responseAt] instanceof Array
                ? response[this.responseAt]
                : response instanceof Array
                    ? response
                    : []
            : response;

        this.page = +response.page || 1;
        this.limit = this.countAt ? +response.limit : modelAttrs.length;
        this.total = this.countAt
            ? +response[this.countAt] || undefined
            : modelAttrs.length;
        
        return this.parseResponse( modelAttrs, response );
    },
    
    parseResponse(modelAttrs, response) {
        return modelAttrs;
    },

    setPage(page) {
        return this.page = page, 
            this.fetch();
    },

    getUrl() {
		let url = this.endpoint;
		for (let name in this.filters) if (this.filters.hasOwnProperty( name ))
            if (undefined !== this.filters[name])
			    url = Config.add( url, name, this.filters[name] );
		
        url = Config.url( url );
        if (this.page)
            url = Config.add( url, 'page', this.page );

        return url;
    },
	
	fetch(options = {}) {
        const defaultUseCache = undefined !== this.options.useCache
            ? this.options.useCache
            : true;

        const { useCache = defaultUseCache } = options;
        
        this.url = useCache 
                ? this.getUrl()
                : `${url( this.getUrl() ).write( 'useCache', false )}`;
        
        // todo: reject
        return new Promise( (resolve, reject) => {
            // manage success handler
            // to maintain active row
            const {success, error} = options;
            options.success = (coll, resp, http) => {
                this.restoreActive();

                if (success)
                    success.call( options.context, this, resp, options );
                    
                resolve( [this.toJSON(), this, resp] );
            };

            options.error = (collection, xhr, options) => {
                this.restoreActive();

                let result = error
                    ? error.call( options.context, collection, xhr, options )
                    : undefined;

                reject( options.errorThrown );

                return result;
            };
            
            Backbone.Collection.prototype.fetch.call( this, options );
        } );
    },
    
    predicate(fn) {
        return Backbone.Collection.prototype.filter.call( this, fn );
    },
	
	filter(name, value, page, activeId) {
        if ('object' === typeof name) {
            this.filters = name;
            activeId = page;
            page = value;
        } else {
            this.filters[name] = value;
        }

        // if active id isn't passed, don't clear current active id
        if (activeId) this.activeId = activeId;
        // if page isn't passed, clear current page
        this.page = page;
            
        return this.fetch();
	},
    
    restoreActive() {
        // this condition will fire if
        // there is no active id in collection
        // (!this.activeId) or there is active id
        // but it's not actual because there
        // is no active record with this id
        // (!this.activeRow())
        if (!this.activeId || !this.activeRow()) {
            // if no active row, try to select first one
            this.length 
                ? this.activate( 0 )
                : this.deactivate();
        }
    },
    
    activate(index) {
        if (index < 0) return;
        if (index >= this.length) return;
        
        this.activeId = this.at( index ).id;
        this.trigger( 'activate' );
    },
    
    deactivate() {
        this.activeId = undefined;
        this.trigger( 'deactivate' );
    },
    
    activeRow() {
        let result = undefined;
        this.forEach( (item, index) => {
            if (this.activeId === item.id) result = index; 
        } );
        return result;
    },
    
    prevRow() {
        let row = this.activeRow();
        if (row > 0)
            this.activate( row - 1 ); 
    },
    
    nextRow() {
        let row = this.activeRow();
        if (row < this.models.length-1)
            this.activate( row + 1 ); 
    },
    
    save(viewOrModel) {
        const model = viewOrModel.model ? viewOrModel.model : viewOrModel;
        const view = viewOrModel.model ? viewOrModel : null;
        // try to find the original model
        // in this collection
        let index;
        let original = this.get( model );
        if (original) index = this.indexOf( original );

        const saving = view ? save( view ) : model.save();
        return promisify( saving ).then( (resp, x) => {
            // if found
            if (original) {
                // merge attributes back 
                original.set( model.attributes );
                // notify subscribers about changes in model
                this.trigger( 'poke', index, original );
            } else {
                // model not found in collection:
                // parse server-passed attributes
                // into the model, because Backbone won't do it
                let parsed = model.parse( resp );
                model.set( parsed );

                // todo: find the position to place model into
                // add new model into the collection;
                // sync event will be fire here
                this.add( model );
            }
        } );
    },
    
    destroy(model) {
        // try to find the original model
        // in this collection
        let index = this.indexOf( this.get( model ) );
        
        // notice how we don't manually remove model
        // from collection, because calling .destroy()
        // automatically does it.
        return model.destroy( { wait: true } ).done( () => {
            // set current active model:
            // 1. if deleted model wasn't the last one,
            //    cursor must stay at the same position.
            //    (next model will be at thos position)
            if (index < this.length)
                this.activeId = this.at( index ).id;
            // 2. otherwise,
            //    cursor must move to one position back.
            else if (index > 0) 
                this.activeId = this.at( index-1 ).id;
                
            // can't use "remove" event for this purpose,
            // cause "remove" will be fired before
            // recalculating this.activeId (few lines earlier)
            // in code.
            this.trigger( 'pull-out', index );
            
            this.fetch( { useCache: false, } ); 
        } );
    },
    
    current() {
        return _.filter( this.models, item => this.activeId === item.id )[0];
    },

    setActions(actions) {
        Object.keys( actions ).forEach( eventName => {
            // skip "default" key in action definition
            if ('defaults' === eventName) return;
            let actionDef = actions[eventName];
            
            // if definition contains single function:
            // convert it into object
            if ('function' === typeof actionDef) 
                actionDef = actions[eventName] 
                    = { handler: actionDef };
            
            // handler's signature contains single argument?
            let handler = actionDef.handler;
            if (handler.toString().match( /^function\s*[^\(]*\([^, \)]+/ )) {
                // this argument is a collection's cursor.
                // So, handling can be done if collection
                // has an active record. Let's modify
                // "disabled()" and "handler()" properties 
                // accordingly.
                let disabled = actionDef.disabled;
                if ('function' === typeof disabled) 
                    actionDef.disabled = () => !this.current() || disabled();
                else if (undefined !== disabled)
                    actionDef.disabled = () => !this.current() || disabled;
                else 
                    actionDef.disabled = () => !this.current();
                    
                actionDef.handler = () => handler( this.current() );
            }
        } );
        
        this.actions = new ActionList( actions );
        // actions state will depend on 
        // statuses' activate and deactivate events
        // (change of active record)
        this.actions.depend( this, 'activate deactivate' );
    },
    
    serialize() {
        return this.toJSON().map( (item, index) => {
            return {
                item: { ...item, model: this.models[index] },
                active: item.id === this.activeId
            };
        } );
    },
    
    plugActionSource(source) {
        if (this.actions)
            this.actions.plug( source );
    },

    unplugActionSource(source) {
        if (this.actions)
          this.actions.unplug( source );
    },

} );


// WEBPACK FOOTER //
// ./src/js/collection.js